import { useQuery }               from '@apollo/client'
import { ArrowUturnLeftIcon }     from '@heroicons/react/20/solid'
import { useState }               from 'react'
import { useDispatch }            from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Button }                 from '../../components/Button'
import CommunityForumThreadForm   from '../../components/Forum/CommunityForumThreadForm'
import { LoadingEllipsis }        from '../../components/Loaders/Loaders'
import { setToasts, showToaster } from '../../features/toaster/toasterSlice'
import { GET_FORUM_THREAD_BY_ID } from '../../graphql/communityForum'
import MainLayout                 from '../../layouts/MainLayout'

export default function CommunityForumEditThread(): JSX.Element {
  const { thread_id }                   = useParams()
  const [ forumThread, setForumThread ] = useState( null )
  const dispatch: any                   = useDispatch()
  const navigate: any                   = useNavigate()

  const { loading, error, refetch } = useQuery( GET_FORUM_THREAD_BY_ID, {
    variables:   { input: { id: thread_id, edit: true } },
    onCompleted: ( { forumThreadById }: any ): void => {
      if ( !forumThreadById ) {
        dispatchMessage( 'error', 'Question not found' )
        navigate( '/forum' )
      }

      setForumThread( forumThreadById )
    },
    onError:     ( error: any ): void => console.error( error )
  } )

  const dispatchMessage: any = ( type: string, message: string ): void => {
    dispatch( setToasts( [ { id: '1', type, message } ] ) )
    dispatch( showToaster( true ) )
  }

  return (
    <MainLayout>
      { loading && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4" /> }
      { !loading &&
        <div className="max-w-screen-3xl mx-auto w-full">
          <div className="flex-grow 2xl:p-8 px-4 py-8 space-y-4 2xl:space-y-8">
            <div className="row">
              <div className="col flex 2xl:-mb-4">
                <div className="flex text-sm font-medium">
                  <Button
                    label="Back"
                    blue
                    onClick={ (): any => navigate( -1 ) }
                    icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                  />
                </div>
              </div>
            </div>

            { forumThread &&
              <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-4 lg:p-5">
                <div className="col flex flex-col w-full">
                  <CommunityForumThreadForm forumThread={ forumThread } refetch={ refetch } />
                </div>
              </div>
            }

            { error &&
              <div className="flex flex-col w-full bg-white rounded-xl p-4 lg:p-5">
                <b>Error occurred when fetching Forum Thread:</b>
                { error.graphQLErrors.map( ( { message }: any, i: number ): any => (
                  <div key={ i } className="flex w-full"><span>{ message }</span></div>
                ) ) }
              </div>
            }
          </div>
        </div>
      }
    </MainLayout>
  )
}
